module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_ext_02_6NW26_1SC_GSK.329fab4a.png";